// eslint-disable-next-line arrow-body-style
export const isManager = (role: ("master" | "manager" | "member" | "administrator")[] | undefined): boolean => {
  return typeof role !== "undefined" && role.includes('manager')
}

// eslint-disable-next-line arrow-body-style
export const isMember = (role: ("master" | "manager" | "member" | "administrator")[] | undefined): boolean => {
  return typeof role !== "undefined" && role.includes('member')
}

// eslint-disable-next-line arrow-body-style
export const isAdministrator = (role: ("master" | "manager" | "member" | "administrator")[] | undefined): boolean => {
  return typeof role !== "undefined" && role.includes('administrator')
}
